const directiveName = 'ltValidateUsername';
const directive = ['$http', '$q', 'MyAccountApiBasePath', ($http: ng.IHttpService, $q: ng.IQService, MyAccountApiBasePath: string) => {

	return {
		require: 'ngModel',
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl: ng.INgModelController) => {

			ctrl.$asyncValidators.usernameAvailability = (modelValue: string, viewValue: string) => {

				if (ctrl.$isEmpty(modelValue)) {
					// consider empty model valid
					return $q.when(false);
				}

				return $http.post<object>(
					MyAccountApiBasePath + '/useridentity/username/available',
					'username=' + encodeURIComponent(modelValue),
					{
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(
					(response: { data: object}): ng.IPromise<boolean> => {
						if (!response.data) {
							return $q.reject(false);
						}
						return $q.resolve(true);
					}
				);
			};

		}
	} as ng.IDirective<ng.IScope, ng.IAugmentedJQuery, ng.IAttributes, ng.INgModelController>;
}];

export default function(module: ng.IModule): void {
	module.directive(directiveName, directive);
}
